<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row class="details">
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col md=12>
                                    <b-table striped small bordered hover :items="organizationInfo" thead-class="hidden_header"></b-table>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12" sm="12">
                            <div class="mb-2" style="font-size: 15px; background-color: #a19e9b; padding: 2px">
                                <h5 class="text-white text-center"> {{ $t('child_admission_management.identity') }}</h5>
                            </div>
                            <b-row>
                                <b-col md=3>
                                    <b-img width='135px' height="130px" :src="url+'download-attachment?file=uploads/admission/online-admission/candidate-imageoriginal/' + onlineAdmission.candidate_image" alt="Candidate Image"></b-img>
                                    <div style="float: right; width: 90px;">
                                        <a :href="url + 'download-attachment?file=uploads/admission/online-admission/candidate-imageoriginal/' + onlineAdmission.candidate_image" title="Candidate Image Download">Attachment Download <i class="ri-download-cloud-fill"></i></a>
                                    </div>
                                </b-col>
                                <b-col md=9>
                                    <b-table striped small bordered hover :items="candidateIndentify" thead-class="hidden_header"></b-table>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col sm="12" style="max-width: 22%">
                                    <p class="text-black" style="border-bottom: 1px solid #ddd; font-size: 15px; font-weight: bold">
                                        {{ $t('child_admission_management.per_address') + ' :' }}
                                    </p>
                                </b-col>
                                <b-col md=12>
                                    <b-table striped small bordered hover :items="permanentAddress" thead-class="hidden_header"></b-table>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="12" style="max-width: 22%">
                                    <p class="text-black" style="border-bottom: 1px solid #ddd; font-size: 15px; font-weight: bold">
                                        {{ $t('child_admission_management.present_address') + ' :' }}
                                    </p>
                                </b-col>
                                <b-col md=12>
                                    <b-table striped small bordered hover :items="presentAddress" thead-class="hidden_header"></b-table>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12" sm="12">
                            <div class="mb-2" style="font-size: 15px; background-color: #a19e9b; padding: 2px">
                                <h5 class="text-white text-center"> {{ $t('child_admission_management.basic_info') }}</h5>
                            </div>
                            <b-row>
                                <b-col md=12>
                                    <!-- <b-table striped small bordered hover :items="basicInfo" thead-class="hidden_header" style="margin-bottom: 0rem !important"></b-table> -->
                                    <b-table-simple striped bordered small hover style="margin-bottom: 0rem !important">
                                        <tbody>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.date_of_birth') }}</b-td>
                                                <b-td>{{ onlineAdmission.date_of_birth | dateFormat }}</b-td>
                                                <b-td>{{ $t('child_admission_management.nationality') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? onlineAdmission.nationality : onlineAdmission.nationality_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.religion') }}</b-td>
                                                <b-td>{{ onlineAdmission.religion ? getReligionName(onlineAdmission.religion) : 'N/A' }}</b-td>
                                                <b-td>{{ $t('child_admission_management.highest_qualification') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? onlineAdmission.h_qualification : onlineAdmission.h_qualification_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.legal_guardian') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? onlineAdmission.legal_guardian : onlineAdmission.legal_guardian_bn }}</b-td>
                                                <b-td>{{ $t('child_admission_management.contact_no') }}</b-td>
                                                <b-td>{{ onlineAdmission.contact_no }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.email') }}</b-td>
                                                <b-td>{{ onlineAdmission.email }}</b-td>
                                                <b-td>{{ $t('child_admission_management.monthly_income') }}</b-td>
                                                <b-td>{{ $n(onlineAdmission.monthly_income) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.profession') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? onlineAdmission.profession : onlineAdmission.profession_bn }}</b-td>
                                                <b-td>{{ $t('child_admission_management.relationship_with_guardian') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? onlineAdmission.rel_with_guardian : onlineAdmission.rel_with_guardian_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.address') }}</b-td>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? onlineAdmission.address : onlineAdmission.address_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td width="30%">{{ $t('child_admission_management.cause_of_death_if_father_dies') }}</b-td>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? onlineAdmission.cause_of_d_father : onlineAdmission.cause_of_d_father_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.cause_of_death_if_mother_dies') }}</b-td>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? onlineAdmission.cause_of_d_mother : onlineAdmission.cause_of_d_mother_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.physical_condition_of_the_hild') }}</b-td>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? onlineAdmission.child_condition : onlineAdmission.child_condition_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.age_and_occupation') }}</b-td>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? onlineAdmission.age_and_occup : onlineAdmission.age_and_occup_bn }}</b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                    <b-table-simple striped bordered small hover>
                                        <tbody>
                                            <b-tr>
                                                <b-td width="80%">{{ $t('child_admission_management.real_sstate_if_any') }}</b-td>
                                                <b-td width="20%">{{ onlineAdmission.real_state ? getAffirmativeName(onlineAdmission.real_state) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td width="80%">{{ $t('child_admission_management.serious_infectious_disease') }}</b-td>
                                                <b-td width="20%">{{ onlineAdmission.infectious_disease ? getAffirmativeName(onlineAdmission.infectious_disease) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td width="80%">{{ $t('child_admission_management.distressed_child_training_and_rehabilitation_center') }}</b-td>
                                                <b-td width="20%">{{ onlineAdmission.has_already_admit ? getAffirmativeName(onlineAdmission.has_already_admit) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td width="80%">{{ $t('child_admission_management.checklist_online_admission_application_test') }}</b-td>
                                                <b-td width="20%">{{ $t('child_admission_management.accepted') }}</b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import Custom from '../../../../../store/custom'

export default {
  props: ['id', 'url'],
  components: {
  },
  data () {
    return {
      onlineAdmission: {
      },
      affirmativeList: [
          { value: 1, text_en: 'Yes', text_bn: 'হ্যাঁ' },
          { value: 2, text_en: 'No', text_bn: 'না' }
      ]
    }
  },
  created () {
    if (this.id) {
        const tmp = this.getOnlineAdmissionData()
        this.onlineAdmission = tmp
    }
  },
  mounted () {
    core.index()
  },
  computed: {
    organizationInfo () {
      return [
        { key: this.$t('globalTrans.organization'), val: this.getOrgName(this.onlineAdmission.org_id), key1: this.$t('child_admission_management.student_type'), val1: this.getStudentType(this.onlineAdmission.student_type) },
        { key: this.$t('child_configuration.institute_type'), val: this.getInstituteType(this.onlineAdmission.office_type_id), key1: this.$t('child_admission_management.registration_id'), val1: this.onlineAdmission.registration_id },
        { key: this.$t('child_configuration.institute_name'), val: this.$i18n.locale === 'en' ? this.onlineAdmission.institute_name : this.onlineAdmission.institute_name_bn, key1: this.$t('globalTrans.fiscal_year'), val1: this.$i18n.locale === 'en' ? this.onlineAdmission.fiscal_year : this.onlineAdmission.fiscal_year_bn }
      ]
    },
    candidateIndentify () {
      return [
        { key: this.$t('child_admission_management.name'), val: this.$i18n.locale === 'en' ? this.onlineAdmission.name : this.onlineAdmission.name_bn },
        { key: this.$t('child_admission_management.father_name'), val: this.$i18n.locale === 'en' ? this.onlineAdmission.father_name : this.onlineAdmission.father_name_bn },
        { key: this.$t('child_admission_management.mother_name'), val: this.$i18n.locale === 'en' ? this.onlineAdmission.mother_name : this.onlineAdmission.mother_name_bn }
      ]
    },
    permanentAddress () {
      return [
        { key: this.$t('org_pro.area_type'), val: this.getAreaType(this.onlineAdmission.area_type_id), key1: this.$t('org_pro_division.division'), val1: this.getDivisionName(this.onlineAdmission.division_id) },
        { key: this.$t('org_pro_district.district'), val: this.getDistrictName(this.onlineAdmission.district_id), key1: this.$t('org_pro_upazilla.upazilla'), val1: this.onlineAdmission.upazila_id ? this.getUpazilaName(this.onlineAdmission.upazila_id) : 'N/A' },
        { key: this.$t('org_pro_union.union'), val: this.onlineAdmission.union_id ? this.getUnionName(this.onlineAdmission.union_id) : 'N/A', key1: this.$t('org_pro.city_corporation'), val1: this.onlineAdmission.city_corporation_id ? this.getCityCorpName(this.onlineAdmission.city_corporation_id) : 'N/A' },
        { key: this.$t('educational_management.pourosoba'), val: this.onlineAdmission.paurasabha_id ? this.getPourosobaName(this.onlineAdmission.paurasabha_id) : 'N/A', key1: this.$t('org_pro.ward'), val1: this.onlineAdmission.ward_id ? this.getWardName(this.onlineAdmission.ward_id) : 'N/A' },
        { key: this.$t('child_admission_management.address'), val: this.$i18n.locale === 'en' ? this.onlineAdmission.per_address : this.onlineAdmission.per_address_bn }
      ]
    },
    presentAddress () {
      return [
        { key: this.$t('org_pro.area_type'), val: this.getAreaType(this.onlineAdmission.pre_area_type_id), key1: this.$t('org_pro_division.division'), val1: this.getDivisionName(this.onlineAdmission.pre_division_id) },
        { key: this.$t('org_pro_district.district'), val: this.getDistrictName(this.onlineAdmission.pre_district_id), key1: this.$t('org_pro_upazilla.upazilla'), val1: this.onlineAdmission.pre_upazila_id ? this.getUpazilaName(this.onlineAdmission.pre_upazila_id) : 'N/A' },
        { key: this.$t('org_pro_union.union'), val: this.onlineAdmission.pre_union_id ? this.getUnionName(this.onlineAdmission.pre_union_id) : 'N/A', key1: this.$t('org_pro.city_corporation'), val1: this.onlineAdmission.pre_city_corporation_id ? this.getCityCorpName(this.onlineAdmission.pre_city_corporation_id) : 'N/A' },
        { key: this.$t('educational_management.pourosoba'), val: this.onlineAdmission.pre_paurasabha_id ? this.getPourosobaName(this.onlineAdmission.pre_paurasabha_id) : 'N/A', key1: this.$t('org_pro.ward'), val1: this.onlineAdmission.pre_ward_id ? this.getWardName(this.onlineAdmission.pre_ward_id) : 'N/A' },
        { key: this.$t('child_admission_management.address'), val: this.$i18n.locale === 'en' ? this.onlineAdmission.pre_address : this.onlineAdmission.pre_address_bn }
      ]
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    getAffirmativeName (Id) {
        const tmpData = this.affirmativeList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getReligionName (Id) {
        const tmpData = this.$store.state.ChildService.commonObj.religionList.find(item => item.value === Id)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getWardName (Id) {
        const tmpData = this.$store.state.commonObj.wardList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getUnionName (Id) {
        const tmpData = this.$store.state.commonObj.unionList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getUpazilaName (Id) {
        const tmpData = this.$store.state.commonObj.upazilaList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getDivisionName (Id) {
        const tmpData = this.$store.state.commonObj.divisionList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getPourosobaName (Id) {
        const tmpData = this.$store.state.commonObj.pauroshobaList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getCityCorpName (Id) {
        const tmpData = this.$store.state.commonObj.cityCorporationList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getDistrictName (Id) {
        const tmpData = this.$store.state.commonObj.districtList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getAreaType (Id) {
        const tmpData = Custom.wardTypeList.find(item => item.id === Id)
        if (this.$i18n.locale === 'bn') {
            return tmpData.name_bn
        } else {
            return tmpData.name
        }
    },
    getOrgName (orgId) {
        const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getInstituteType (Id) {
        const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getStudentType (typeId) {
        const Type = this.$store.state.ChildService.commonObj.studentTypeList.find(type => type.value === typeId)
        if (this.$i18n.locale === 'bn') {
            return Type.text_bn
        } else {
            return Type.text_en
        }
    },
    getOnlineAdmissionData () {
        const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
        return JSON.parse(JSON.stringify(tmpData))
    }
  }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
